import Colors from '../assets/colors.json'

export const ColorsDeprecated = Colors
